module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myposts"
  }, [(_vm.user !== null) ? [(_vm.isFetching) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }]
  }) : (_vm.myPosts.length === 0) ? _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "新增一個Project!"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.newPostForCurrentUser($event)
      }
    },
    model: {
      value: (_vm.newPostTitle),
      callback: function($$v) {
        _vm.newPostTitle = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "newPostTitle"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.newPostForCurrentUser
    }
  }, [_vm._v("建立")])], 1) : _c('div', [_c('editor', {
    attrs: {
      "postData": _vm.myPosts[0]
    },
    on: {
      "cancel": function($event) {
        _vm.$emit('close')
      }
    }
  })], 1)] : _c('p', [_vm._v("錯誤：請先登入！")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3357b1ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/hackingmap/MyPosts.vue
// module id = 965
// module chunks = 1